<template>
  <div v-if="answer">
    <p
      class="text-base leading-6 text-green  tracking-wide uppercase font-bebas text-lg tracking-wider"
    >
      {{ question }}
    </p>
    <vue-markdown :source="answer" class="text-gray-700 text-base prose"></vue-markdown>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";
export default {
  name: "QuestionAnswer",
  components: {
    VueMarkdown
  },
  props: {
    question: {
      type: String,
      required: true
    },
    answer: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped></style>
